import { SearchController } from '../modules/search_controller'

$(function () {
  const $block = $('.b-search-results')
  if (!$block.length) return

  $block.each(function () {
    const $this = $(this)
    const $scrollTrigger = $this.find('.scroll-trigger')
    const $container = $this.find('.result-container')
    const $spinner = $this.find('.b-spinner')
    const path = $container.data('path')
    const name = $container.data('name')

    if (!name) return

    SearchController.init($container, path, name)
    SearchController.set_page_number(1)
    SearchController.set_spinner($spinner)

    let isLoading = false

    SearchController.set_finish_event(function () {
      if (observer) observer.disconnect()
    })

    const triggerEl = $scrollTrigger.get(0)
    if (!triggerEl) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !isLoading) {
            isLoading = true

            SearchController.load(() => {
              isLoading = false
            })
          }
        })
      },
      {
        rootMargin: '300px',
        threshold: 0.1,
      }
    )

    observer.observe(triggerEl)
  })
})
